import { adjustForLocalOffset } from '../../../../global/helpers/date-helpers';
import { AEOffering } from '../../../annual-enrollment/models/annual-enrollment-models';
import { None } from '../../constants/constant-strings';
import { MidYearEnrollment, MidYearEnrollmentFormValue, MidYearPlanType } from './mid-year-model';

export const planExists = (enrollment: MidYearEnrollment, midYearPlanType: MidYearPlanType) => {
	return enrollment?.enrollments_base &&
		enrollment?.enrollments_base[midYearPlanType] &&
		enrollment?.enrollments_base[midYearPlanType][0]?.code &&
		enrollment?.enrollments_base[midYearPlanType][0]?.code !== None;
};

export const getPlanFormData = (planName: string, existsPlan: boolean, midYearState: MidYearEnrollment, midYearPlanType: MidYearPlanType) => {
	const haveVolume = midYearPlanType !== MidYearPlanType.Dental && midYearPlanType !== MidYearPlanType.Medical;
	const noVolume = {
		[`${planName}BillingAccount`]: existsPlan ? midYearState?.enrollments_base?.[midYearPlanType][0]?.account_nbr : '',
		[planName]: existsPlan ? midYearState?.enrollments_base?.[midYearPlanType][0]?.code : '',
		[`${planName}EffectiveDate`]: existsPlan && midYearState?.enrollments_base?.[midYearPlanType][0]?.effective_date ?
			adjustForLocalOffset(new Date(midYearState?.enrollments_base?.[midYearPlanType][0]?.effective_date)).toString() : null,
		[`${planName}TerminateDate`]: existsPlan && midYearState?.enrollments_base?.[midYearPlanType][0]?.termination_date ?
			adjustForLocalOffset(new Date(midYearState?.enrollments_base?.[midYearPlanType][0]?.termination_date)).toString() : null,
	};
	return haveVolume ?
		{
			...noVolume,
			[`${planName}Volume`]: existsPlan ? midYearState?.enrollments_base?.[midYearPlanType][0]?.volume : '',
		}
		: noVolume;

};

const characterMax = 255;

export const getRemainingCharacterCounter = (current: number) => {
	if (current) return characterMax - current > 0 ? characterMax - current : 0;
	return characterMax;
};

export const hasAvailablePlans = (enrollment: MidYearEnrollment) => {
	const offeringKeys = enrollment?.offerings ? Object.keys(enrollment.offerings) : [];

	for (let i = 0; i < offeringKeys.length; i += 1) {
		const offering: AEOffering = enrollment.offerings[offeringKeys[i]];

		if (offering?.plans?.length > 0) return true;
	}


	return false;
};


export function ShouldShowAdminCafeteriaAcknowledgement(initialValues: MidYearEnrollmentFormValue, formValues: MidYearEnrollmentFormValue, numberOfDays: number) {

	if (formValues?.date_of_qualifying_event === null || formValues?.date_of_qualifying_event === undefined) return false;
	//This method compare both objects and return if they are exactly the same, and false if they are different
	const formHasChanges = ((initial, form) => Object.entries(initial).every(([key, value]) => form[key] === value))(initialValues, formValues);

	return numberOfDays > 30 && !formHasChanges;
}